export default __webpack_public_path__ + "static/iPhoneFrameCutOffMedium-28d76bb9e519ae393a83768f2bcc9c05.png";